import Svg, { SvgProps } from './Svg';

export default function DoubleChevronRight({
  color = 'currentColor',
  ...props
}: SvgProps) {
  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="m6 17 5-5-5-5"></path>
      <path d="m13 17 5-5-5-5"></path>
    </Svg>
  );
}
